import EquipmentManage from "./EquipmentManage";

export default EquipmentManage;
export { EquipmentManage };
